import { useState } from "react";
import Toast from "@/components/base/Toast";

export default function SubscribeBand() {
  const [email, setEmail] = useState("");
  const [toast, setToast] = useState<string | null>(null);

  const handleSubscribe = () => {
    setToast(
      email.trim()
        ? "已记录你的邮箱（演示效果，不会真实发送）"
        : "填个邮箱再订阅吧（演示效果）",
    );
    window.setTimeout(() => setToast(null), 2400);
  };

  return (
    <section className="w-full border-b border-background-200 bg-primary-500">
      <div className="mx-auto grid w-full max-w-page grid-cols-1 items-center gap-6 px-4 py-10 md:px-6 md:py-12 lg:grid-cols-2 lg:gap-10">
        <div>
          <h2 className="font-heading text-2xl leading-tight text-background-50 md:text-3xl">
            头版一出，第一时间知道
          </h2>
          <p className="mt-2.5 text-sm leading-relaxed text-background-50/85 md:text-base">
            订阅后，每当有新的置顶爆料或今日要闻被顶到最前，我们会把当天最值得看的几条整理成一条推送。
          </p>
        </div>
        <div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="输入你的邮箱"
              className="w-full flex-1 rounded-md border border-primary-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button
              type="button"
              onClick={handleSubscribe}
              className="inline-flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm text-foreground-950 transition-colors hover:bg-accent-400 sm:w-auto"
            >
              <i className="ri-mail-send-line" />
              订阅头条
            </button>
          </div>
          <p className="mt-2.5 flex items-center gap-1.5 text-xs text-background-50/75">
            <i className="ri-information-line" />
            演示站点，订阅按钮不会真实提交任何信息。
          </p>
        </div>
      </div>
      <Toast message={toast} />
    </section>
  );
}